import React from "react";
import { Card, CardContent, Typography } from "@mui/material";

const ContactCard: React.FC<any> = ({ data }) => {
  return (
    <Card variant="outlined">
      <CardContent>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          {data.type}
        </Typography>
        <Typography variant="h5" component="div">
          {data.name}
        </Typography>
        <Typography variant="h6" component="div">
          {data.org}
        </Typography>
        <Typography sx={{ mb: 1.5 }} color="text.secondary">
          {data.phone}
        </Typography>
        <Typography variant="body2">{data.address}</Typography>
        <Typography variant="body2">{data.extra}</Typography>
      </CardContent>
    </Card>
  );
};

export default ContactCard;
